// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";
import { getToken } from "./localStorageService";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const businessTypeApi = baseApi.injectEndpoints({

  credentials: "include",
  endpoints: (builder) => ({
    addBusinessType: builder.mutation({
      query: (data) => {
        return {
          url: "business-types",
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    updateBusinessType: builder.mutation({
      query: ({data, slug}) => {
        return {
          url: `business-types/${slug}`,
          method: "PATCH",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    deleteBusinessType: builder.mutation({
      query: (slug) => {
        return {
          url: `business-types/${slug}`,
          method: "DELETE",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    getAllBusinessType: builder.query({
      query: ({ limit, skip }) => {
        return {
          url: `business-types?limit=${limit}&skip=${skip}`, // todo:
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          // },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useAddBusinessTypeMutation,
  useUpdateBusinessTypeMutation,
  useDeleteBusinessTypeMutation,
  useGetAllBusinessTypeQuery,
} = businessTypeApi;
